import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import Search from '@material-ui/icons/Search';

import React from 'react';



const UsersListSearch = ({ searchText, onSearchTextUpdated }) => {



    return <FormControl >
        <InputLabel htmlFor="adornment-password">Search Users</InputLabel>
        <Input
            id="adornment-password"
            type="text"
            value={searchText}
            onChange={event => onSearchTextUpdated(event.target.value)}
            endAdornment={
                <InputAdornment position="end">
                    <   Search />
                </InputAdornment>
            }
        />
    </FormControl>
}

export default UsersListSearch;